import "./polyfills"; // For IE 11 support
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ApolloProvider } from "react-apollo";
import { AuthProvider } from "./lib/auth";
import apolloClient from "./ApolloClient";
import "bootstrap/dist/css/bootstrap.css";
import "react-instantsearch-theme-algolia/style.css";
import "./index.css";
import App from "./components/App";
import RaygunUser from "./Raygun";
import { unregister } from "./registerServiceWorker";
import RouteChangeHandler from "./lib/Segment/RouteChangeHandler";

// Defensive patch for IntersectionObserver to prevent Google Maps crashes
// when observing elements that have been removed from the DOM
if (typeof IntersectionObserver !== "undefined") {
  const originalObserve = IntersectionObserver.prototype.observe;
  IntersectionObserver.prototype.observe = function (target) {
    if (target instanceof Element && document.contains(target)) {
      return originalObserve.call(this, target);
    }
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.warn(
        "IntersectionObserver.observe called with invalid target, ignoring:",
        target
      );
    }
  };
}

ReactDOM.render(
  <ApolloProvider client={apolloClient}>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <AuthProvider>
        <App />
        <RouteChangeHandler />
        <RaygunUser />
      </AuthProvider>
    </BrowserRouter>
  </ApolloProvider>,
  document.getElementById("root")
);
unregister();
